import React, { Component } from "react";

import Video from "../../Components/Video";

class HetBoek extends Component {
  render() {
    return (
      <div className="het-boek">
        <Video video={"https://www.youtube.com/embed/v1FYHzrv_mM"} />
      </div>
    );
  }
}

export default HetBoek;
